var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakersmin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e0e2e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12a3.5 3.5 0 10-3.5-3.5A3.5 3.5 0 009 12zm-7 5.25c0-2.33 4.66-3.5 7-3.5s7 1.17 7 3.5V19H2zm7-1.5A9.65 9.65 0 004.34 17h9.32A9.65 9.65 0 009 15.75zm1.5-7.25A1.5 1.5 0 109 10a1.5 1.5 0 001.5-1.5zm5.5 5.31a4.19 4.19 0 012 3.44V19h4v-1.75c0-2.02-3.5-3.17-6-3.44zm2.5-5.31A3.5 3.5 0 0115 12a3.4 3.4 0 01-1.5-.35 5.47 5.47 0 000-6.3A3.4 3.4 0 0115 5a3.5 3.5 0 013.5 3.5z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakersmin);
export default __webpack_public_path__ + "static/media/speakers.min.6c60114b2b88ca2bea9d7f84c4ad8ff4.svg";
export { ForwardRef as ReactComponent };